import { FC } from "react";

import MachineContainer from "@app/containers/machine";

const AddMachinePage: FC = () => <MachineContainer />;

export default AddMachinePage;
